import { ImpressionSource } from 'src/app/@utils/gtm-tracking/events/trackProductImpressionEvent';
import { Product } from 'src/app/@utils/gtm-tracking/model';
import { removeEmpty } from 'src/app/@utils/remove-empty.helper';

import { BasketCalculatedLineViewModel } from '@models/api-orders.models';
import {
    calculateUnitDiscountAmount,
    calculateUnitPriceAmountWithDiscount
} from '@utils/gtm-tracking/utils/calculateLineTotal';

type TrackableProduct = Partial<BasketCalculatedLineViewModel> &
    Partial<{
        list: ImpressionSource;
        listId: string;
        quantity: string | number;
        initialQuantity: number;
        location: string;
        index: number;
    }>;

export const mapToBasketAddRemoveTrackableProduct = (product: TrackableProduct): Product => {
    const {
        productName,
        priceAmountRaw = 0,
        variantNo,
        brand,
        list,
        listId,
        quantity = 1,
        initialQuantity = 1,
        discountAmountRaw = 0,
        webCategoryL1,
        webCategoryL2,
        webCategoryL3,
        webCategoryL4,
        materialMulti,
        primaryColor,
        index
    } = product;

    return removeEmpty({
        item_name: productName,
        item_id: variantNo,
        discount: calculateUnitDiscountAmount(initialQuantity, discountAmountRaw),
        price: calculateUnitPriceAmountWithDiscount(initialQuantity, priceAmountRaw),
        item_brand: brand || '',
        item_list_name: list,
        item_list_id: listId,
        quantity: quantity || 1,
        item_variant: primaryColor?.text || materialMulti?.join(', ') || '',
        item_category: webCategoryL1?.text || '',
        item_category_2: webCategoryL2?.text,
        item_category_3: webCategoryL3?.text,
        item_category_4: webCategoryL4?.text,
        index
    }) as Product;
};
